import * as Yup from "yup";

// Flow variables are always stored with `value_required: true`, so that flag
// cannot be used to tell mandatory fields apart from optional ones. The real
// signal is `is_optional`, which is what the Translations tab toggles. A
// variable is mandatory only when it is not explicitly marked optional.
// Missing `is_optional` defaults to required for backward compatibility with
// older flows created before the flag existed.
export const isVariableRequired = (variable) => !variable?.is_optional;

// Builds the Yup validation entries for the dynamic flow-variable fields so the
// Demo Call Portal enforces exactly the required/optional rules configured in
// the Translations tab. Format checks (10-digit phone, valid JSON array list)
// still apply when a value is provided, even for optional fields.
export const buildVariableValidations = (fieldNames, variables) =>
  fieldNames.reduce((acc, fieldName) => {
    if (!fieldName) {
      return acc;
    }
    const variable = variables.find((item) => item.name === fieldName);
    const required = isVariableRequired(variable);

    let schema;
    if (variable?.type === "phone") {
      schema = Yup.string().matches(/^[0-9]{10}$/, {
        message: `${fieldName} must be 10 digit`,
        excludeEmptyString: true,
      });
    } else if (variable?.type === "list") {
      schema = Yup.string().test(
        "is-valid-json-array",
        `${fieldName} must be a valid JSON array`,
        (value) => {
          if (!value) {
            // Empty is only an error when the field is required; the
            // `.required()` rule below reports that so the format check passes.
            return true;
          }
          try {
            return Array.isArray(JSON.parse(value));
          } catch (e) {
            return false;
          }
        }
      );
    } else {
      schema = Yup.string();
    }

    acc[fieldName] = required
      ? schema.required(`${fieldName} is required`)
      : schema;
    return acc;
  }, {});
